// Addresses that come from call recordings, CRM leads and calendar invites are typed or imported by
// people and systems, so they are never trusted as links. Only a real http(s) address is returned;
// anything else (javascript:, data:, plain text, a non-string) gives null and the screen shows no link.
export function safeHttpUrl(value) {
  if (typeof value !== "string") return null;
  const text = value.trim();
  try {
    const url = new URL(text);
    return url.protocol === "http:" || url.protocol === "https:" ? text : null;
  } catch {
    return null;
  }
}
